import { useState } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import ColorSchema from "../Color";
export default function TimeLine({ bgColor, Icon, children }) {
  return (
    <>
      <VerticalTimeline
        layout="1-column-right"
        lineColor="lightgray"
        className="mt-5"
      >
        <VerticalTimelineElement
          className="vertical-timeline-element--work "
          iconStyle={{ background: bgColor }}
          iconClassName="d-flex justify-content-end align-items-center"
          icon={Icon}
        >
          {children}
        </VerticalTimelineElement>
      </VerticalTimeline>
    </>
  );
}
